import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { ChatCircleDotsIcon as ChatCircleDots } from "@phosphor-icons/react";

// "Message" button for public profiles. Hides for your own profile.
export const MessageUserButton = ({ userId, className = "" }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (!userId || (user && user.id === userId)) return null;
  const go = () => {
    if (!user) { navigate("/login"); return; }
    navigate(`/messages?to=${userId}`);
  };
  return (
    <Button
      variant="outline"
      onClick={go}
      className={`rounded-full text-[12px] h-9 ${className}`}
      data-testid={`message-user-btn-${userId}`}
    >
      <ChatCircleDots size={15} weight="duotone" className="mr-1.5" /> Message
    </Button>
  );
};

export default MessageUserButton;
